export function setupSeccion() {
  if (!document.body.classList.contains("archive")) return;

  const contenido_tres_columnas = document.querySelector(
    ".contenido_tres_columnas"
  );

  if (!contenido_tres_columnas) return;

  const noticias = contenido_tres_columnas.querySelectorAll(
    ".noticia__container"
  );
  if (!noticias) return;

  if (noticias.length < 3) {
    if (noticias.length == 2)
      contenido_tres_columnas.classList.add(
        "contenido_tres_columnas--cantidad-2"
      );
    if (noticias.length == 1)
      contenido_tres_columnas.classList.add(
        "contenido_tres_columnas--cantidad-1"
      );
  }
}
